import { Modal } from 'antd';
import deleteOrder from '../../../Services/deleteOrder';

const { confirm } = Modal;

export default () => async (dispatch) => {

  confirm({
    title: `Are you sure you want to delete this Order?`,
    content: 'Note: This action cannot be undone',
    okText: 'Yes, Delete it',
    onOk() {
      
      dispatch(deleteOrder());
      
    }
  });

}